export default [
    {
        path: '/activity-offered-modalities',
        name: 'activity-offered-modalities',
        component: () => import ('./views/ActivityOfferedModalityIndex'),
        meta: { title: 'Modalidades', icon: 'mdi-shape-outline' },
    },
]
